/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The status of the Spark engine
*/
export enum SparkEngineStatus {
  SPARK_ENGINE_STATUS_CREATING = 'CREATING',
  SPARK_ENGINE_STATUS_PROVISIONING = 'PROVISIONING',
  SPARK_ENGINE_STATUS_PROVISIONED = 'PROVISIONED',
  SPARK_ENGINE_STATUS_STARTING = 'STARTING',
  SPARK_ENGINE_STATUS_RUNNING = 'RUNNING',
  SPARK_ENGINE_STATUS_STOPPING = 'STOPPING',
  SPARK_ENGINE_STATUS_STOPPED = 'STOPPED',
  SPARK_ENGINE_STATUS_DEPROVISIONING = 'DEPROVISIONING',
  SPARK_ENGINE_STATUS_DEPROVISIONED = 'DEPROVISIONED',
  SPARK_ENGINE_STATUS_DELETING = 'DELETING',
  SPARK_ENGINE_STATUS_FAILED = 'FAILED'
}
